<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-1">
        <h6 class="modal-title">{{ title }}</h6>
        <div class="flex-fill"></div>
        <ng-template [ngTemplateOutlet]="actions"></ng-template>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box p-3">
        <div *ngIf="data?.isClone">
          <alert type="warning">
            <i class="far fa-exclamation-triangle"></i>
            <ng-container i18n
              >Warning: This booking is a clone. Please modify the details, before clicking Save to create the
              booking.</ng-container
            >
          </alert>
        </div>
        <form [formGroup]="form">
          <div class="">
            <h6 class="section-title" i18n>Guest Details</h6>
            <mat-form-field2 class="mat-block mb-3" [showLabel]="false">
              <app-select
                bindLabel="name"
                bindValue="id"
                [searchable]="true"
                (searchChange)="guestSearch.next($event)"
                [multiple]="false"
                [items]="guests$ | async"
                i18n-placeholder
                formControlName="guestId"
                placeholder="Search for Guest (optional)"
              ></app-select>
              <i
                matSuffix
                *ngIf="form.get('guestId').value"
                class="far fa-times clickable text-danger"
                (click)="onClearSelectedGuest()"
              ></i>
            </mat-form-field2>
            <div class="d-grid gap-col-3" style="grid-template-columns: 1fr 1fr 1fr">
              <mat-form-field2 class="mat-block">
                <input
                  type="text"
                  formControlName="guestName"
                  matInput
                  required
                  i18n-placeholder
                  placeholder="Guest Name"
                />
                <mat-error *ngIf="form.get('guestName').touched && form.get('guestName').hasError('required')">
                  <ng-container i18n>Name is required</ng-container>
                </mat-error>
                <mat-error *ngIf="form.get('guestName').touched && form.get('guestName').hasError('minlength')">
                  <ng-container i18n>Name must be at least 2 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="form.get('guestName').touched && form.get('guestName').hasError('maxlength')">
                  <ng-container i18n>Name must be at most 50 characters long</ng-container>
                </mat-error>
              </mat-form-field2>
              <mat-form-field2 class="mat-block">
                <input
                  type="text"
                  formControlName="guestEmail"
                  matInput
                  required
                  i18n-placeholder
                  placeholder="Guest Email"
                />
                <mat-error *ngIf="form.get('guestEmail').touched && form.get('guestEmail').hasError('required')">
                  <ng-container i18n>Email is required</ng-container>
                </mat-error>
                <mat-error *ngIf="form.get('guestEmail').touched && form.get('guestEmail').hasError('email')">
                  <ng-container i18n>Email must have valid format</ng-container>
                </mat-error>
              </mat-form-field2>
              <app-phone-number-input
                [ctrl]="form.get('guestPhone')"
                placeholder="Guest Phone"
              ></app-phone-number-input>
              <mat-form-field2 class="mat-block">
                <mat-select
                  formControlName="source"
                  i18n-placeholder
                  placeholder="Source:"
                  [required]="true"
                  (selectionChange)="engineCost.next('')"
                >
                  <mat-option *ngFor="let channel of channels$ | async" [value]="channel.id">{{
                    channel.label
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('source').touched && form.get('source').hasError('required')">
                  <ng-container i18n>Channel is required</ng-container>
                </mat-error>
              </mat-form-field2>
              <mat-form-field2 class="mat-block">
                <input
                  type="number"
                  min="1"
                  step="1"
                  (change)="engineCost.next('')"
                  formControlName="adults"
                  matInput
                  required
                  i18n-placeholder
                  placeholder="Adults"
                />
                <mat-error *ngIf="form.get('adults').touched && form.get('adults').hasError('required')">
                  <ng-container i18n>Adults field is required</ng-container>
                </mat-error>
                <mat-error *ngIf="form.get('adults').hasError('pattern')">
                  <ng-container i18n>Adults field must be a whole number</ng-container>
                </mat-error>
              </mat-form-field2>
              <mat-form-field2 class="mat-block">
                <input
                  type="number"
                  min="0"
                  step="1"
                  (change)="engineCost.next('')"
                  formControlName="children"
                  matInput
                  i18n-placeholder
                  placeholder="Children"
                />
                <mat-error *ngIf="form.get('children').touched && form.get('children').hasError('pattern')">
                  <ng-container i18n>Children field must be a whole number</ng-container>
                </mat-error>
              </mat-form-field2>
            </div>
          </div>
          <div class="cost-error">
            <mat-error *ngIf="overMaxGuests$ | async as maxGuests"
              ><ng-container i18n> Maximum guests is </ng-container>{{ maxGuests }}
            </mat-error>
            <mat-error *ngIf="underMinGuests$ | async as minGuests"
              ><ng-container i18n> Minimum guests is </ng-container>{{ minGuests }}
            </mat-error>
          </div>

          <div class="">
            <h6 class="section-title" i18n>Charges Details</h6>
            <div class="d-grid gap-col-3" style="grid-template-columns: 1fr 1fr 1fr">
              <app-rental-select
                [multiple]="false"
                [ctrl]="form.get('rentalId')"
                [excludeDisabledSubunits]="true"
                i18n-placeholder
                placeholder="Rental"
              >
              </app-rental-select>
              <mat-form-field2 class="mat-block">
                <input
                  matInput
                  [matDatepicker]="arriveDate"
                  i18n-placeholder
                  placeholder="Arrive"
                  [min]="minDateDefault"
                  [max]="maxArriveDate.value || maxDateDefault"
                  [required]="true"
                  (focus)="arriveDate.open()"
                  (dateChange)="engineCost.next('')"
                  (dateInput)="engineCost.next('')"
                  formControlName="arriveDate"
                  readonly
                />
                <i matPrefix (click)="arriveDate.open()" class="cs-icon cs-icon-calendar"></i>
                <mat-datepicker #arriveDate></mat-datepicker>
                <mat-error *ngIf="form.get('arriveDate').touched && form.get('arriveDate').hasError('required')">
                  <ng-container i18n>Arrive is required</ng-container>
                </mat-error>
                <mat-hint class="text-danger" *ngIf="underMinStay$ | async"
                  ><ng-container i18n>Minimum stay is </ng-container>{{ cost.value?.minimumstay }}</mat-hint
                >
                <mat-hint class="text-danger" *ngIf="overMaxStay$ | async"
                  ><ng-container i18n>Maximum stay is </ng-container>{{ cost.value?.maximumstay }}</mat-hint
                >
              </mat-form-field2>
              <mat-form-field2 class="mat-block">
                <input
                  matInput
                  [matDatepicker]="departDate"
                  i18n-placeholder
                  placeholder="Depart"
                  [required]="true"
                  [min]="minDepartDate.value || minDateDefault"
                  [max]="maxDateDefault"
                  (dateChange)="engineCost.next('')"
                  (dateInput)="engineCost.next('')"
                  (focus)="departDate.open()"
                  formControlName="departDate"
                  readonly
                />
                <i matPrefix (click)="departDate.open()" class="cs-icon cs-icon-calendar"></i>
                <mat-datepicker #departDate></mat-datepicker>
                <mat-error *ngIf="form.get('departDate').touched && form.get('departDate').hasError('required')">
                  <ng-container i18n>Depart is required</ng-container>
                </mat-error>
                <mat-error *ngIf="form.get('departDate').hasError('matDatepickerMin')">
                  <ng-container i18n>Min value is</ng-container>&nbsp;
                  <strong>{{ form.get('departDate').getError('matDatepickerMin').min | epoch : 'DD-MMM-YYYY' }}</strong>
                </mat-error>
              </mat-form-field2>
              <mat-form-field2 class="mat-block">
                <input
                  type="number"
                  min="0"
                  formControlName="charge"
                  (keyup)="onChargeChange($event.target.value)"
                  matInput
                  placeholder="Base Charge:"
                  i18n-placeholder
                  [required]="true"
                />
                <mat-error *ngIf="form.get('charge').touched && form.get('charge').hasError('required')">
                  <ng-container i18n>Base Charge is required</ng-container>
                </mat-error>
              </mat-form-field2>
              <div
                formArrayName="discounts"
                *ngFor="let item of discounts.controls; let i = index; let last = last; let first = first"
                class="d-flex gap-3"
              >
                <mat-form-field2 class="mat-block" [formGroupName]="i">
                  <input
                    type="number"
                    (change)="engineCost.next('')"
                    formControlName="amount"
                    matInput
                    i18n-placeholder
                    placeholder="Discounts & Fees:"
                  />
                  <mat-error *ngIf="item.get('amount').hasError('zero')"
                    ><ng-container i18n> Value shouldn't be zero. </ng-container></mat-error
                  >
                </mat-form-field2>
                <button
                  *ngIf="last && discounts.length < discountsOrFeesLimit"
                  (click)="addDiscountsOrFees()"
                  class="btn btn-primary btn-circle align-input-row-end"
                  matTooltip="Add new Discount or Fee"
                  i18n-matTooltip
                  type="button"
                >
                  <i class="fas fa-plus"></i>
                </button>
                <button
                  *ngIf="last && !first"
                  (click)="removeDiscountsOrFees(i)"
                  class="btn btn-danger btn-circle align-input-row-end"
                  matTooltip="Remove this Discount/Fee"
                  i18n-matTooltip
                  type="button"
                >
                  <i class="fal fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="d-grid gap-col-3" style="grid-template-columns: 1fr 1fr 1fr">
              <mat-form-field2 class="mat-block" *ngIf="!!cost.value?.extraGuests">
                <input
                  type="number"
                  [value]="cost.value?.extraGuests"
                  matInput
                  disabled
                  i18n-placeholder
                  placeholder="Additional Guests Fee:"
                />
              </mat-form-field2>
              <ng-container *ngFor="let item of cost?.value?.auditDiscounts">
                <mat-form-field2 class="mat-block">
                  <input
                    type="number"
                    [value]="item.disc_amount"
                    matInput
                    disabled
                    [placeholder]="item.disc_type === 'lengthofstay' ? 'LOS Discount' : 'Discount Code'"
                  />
                  <i matSuffix class="fal fa-eye clickable" (click)="onViewDiscount(item)"></i>
                </mat-form-field2>
              </ng-container>
            </div>
            <div [class.hidden]="fees.controls.length === 0" class="mb-3">
              <h6 class="section-title" i18n>Booking Fees</h6>
              <div
                formArrayName="fees"
                *ngFor="let item of fees.controls; let i = index"
                class="d-grid align-items-center bg-active2 p-3 rounded gap-col-3 mb-3"
                style="grid-template-columns: min-content repeat(4, 1fr)"
              >
                <ng-container [formGroupName]="i">
                  <mat-checkbox
                    formControlName="selected"
                    #feeSelected
                    (change)="updateBookingFees()"
                    [matTooltip]="feeSelected.checked ? 'Uncheck to ignore this fee' : 'Check to apply this fee'"
                    class="mr-3"
                  ></mat-checkbox>
                  <mat-form-field2 [matTooltip]="item.get('name')?.value" matTooltipPosition="above" class="mat-block">
                    <input type="text" formControlName="name" matInput i18n-placeholder placeholder="Fee Name:" />
                  </mat-form-field2>
                  <mat-form-field2 class="mat-block">
                    <mat-label
                      ><span
                        [innerHtml]="
                          'Fee Rate (' + (item.get('type')?.value === 'flat' ? rental?.currency?.symbol : '%') + '):'
                        "
                      ></span
                    ></mat-label>
                    <input type="number" min="0" formControlName="rate" matInput />
                  </mat-form-field2>
                  <mat-form-field2
                    class="mat-block"
                    [matTooltip]="feeModalityLabels[item.get('modality')?.value]"
                    matTooltipPosition="above"
                  >
                    <mat-select formControlName="modality" i18n-placeholder placeholder="Modality">
                      <mat-option [value]="feeModalities.PerStay">{{
                        feeModalityLabels[feeModalities.PerStay]
                      }}</mat-option>
                      <mat-option [value]="feeModalities.PerNight">{{
                        feeModalityLabels[feeModalities.PerNight]
                      }}</mat-option>
                      <mat-option [value]="feeModalities.PerPerson">{{
                        feeModalityLabels[feeModalities.PerPerson]
                      }}</mat-option>
                      <mat-option [value]="feeModalities.PerPersonPerNight">{{
                        feeModalityLabels[feeModalities.PerPersonPerNight]
                      }}</mat-option>
                      <mat-option [value]="feeModalities.PerDays">{{
                        feeModalityLabels[feeModalities.PerDays]
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field2>
                  <mat-form-field2 class="mat-block">
                    <span
                      matPrefix
                      [innerHtml]="rental?.currency?.symbol"
                      *ngIf="!(item.get('amount').value | isNil)"
                    ></span>
                    <input
                      type="number"
                      min="0"
                      formControlName="amount"
                      matInput
                      i18n-placeholder
                      placeholder="Fee Amount:"
                    />
                  </mat-form-field2>
                </ng-container>
              </div>
            </div>
            <div [class.hidden]="potentialFees.controls.length === 0" class="mb-3">
              <h6 class="section-title" i18n>These booking fees may apply</h6>
              <div
                formArrayName="potentialFees"
                *ngFor="let item of potentialFees.controls; let i = index"
                class="d-grid gap-col-3"
                style="grid-template-columns: 1fr 1fr 1fr"
              >
                <ng-container [formGroupName]="i">
                  <mat-form-field2 [matTooltip]="item.get('name')?.value" matTooltipPosition="above" class="mat-block">
                    <input type="text" formControlName="name" matInput i18n-placeholder placeholder="Fee Name:" />
                  </mat-form-field2>
                  <mat-form-field2 class="mat-block">
                    <mat-label
                      ><span
                        [innerHtml]="
                          'Fee Rate (' + (item.get('type')?.value === 'flat' ? rental?.currency?.symbol : '%') + '):'
                        "
                      ></span
                    ></mat-label>
                    <input type="number" min="0" formControlName="rate" matInput />
                  </mat-form-field2>
                  <mat-form-field2
                    class="mat-block"
                    [matTooltip]="feeModalityLabels[item.get('modality')?.value]"
                    matTooltipPosition="above"
                  >
                    <mat-select formControlName="modality" placeholder="Modality" i18n-placeholder>
                      <mat-option [value]="feeModalities.PerStay">{{
                        feeModalityLabels[feeModalities.PerStay]
                      }}</mat-option>
                      <mat-option [value]="feeModalities.PerNight">{{
                        feeModalityLabels[feeModalities.PerNight]
                      }}</mat-option>
                      <mat-option [value]="feeModalities.PerPerson">{{
                        feeModalityLabels[feeModalities.PerPerson]
                      }}</mat-option>
                      <mat-option [value]="feeModalities.PerPersonPerNight">{{
                        feeModalityLabels[feeModalities.PerPersonPerNight]
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field2>
                  <mat-form-field2 class="mat-block">
                    <span
                      matPrefix
                      [innerHtml]="rental?.currency?.symbol"
                      *ngIf="!(item.get('amount').value | isNil)"
                    ></span>
                    <input
                      type="number"
                      min="0"
                      formControlName="amount"
                      matInput
                      i18n-placeholder
                      placeholder="Fee Amount:"
                    />
                  </mat-form-field2>
                </ng-container>
              </div>
            </div>
            <div class="cost-error">
              <mat-error *ngIf="isCheckinBlocked$ | async">
                <ng-container i18n
                  >Check-in is not allowed on the selected date. Please choose another date.</ng-container
                >
              </mat-error>
              <mat-error *ngIf="isCheckoutBlocked$ | async">
                <ng-container i18n
                  >Check-out is not allowed on the selected date. Please choose another date.</ng-container
                >
              </mat-error>
              <mat-error *ngIf="minAdvanceDays$ | async as minAdvanceDays">
                <ng-container i18n>Minimum Advance Booking is</ng-container> {{ minAdvanceDays }}
                <ng-container *ngIf="minAdvanceDays > 1" i18n>days</ng-container
                ><ng-container *ngIf="minAdvanceDays === 1" i18n>day</ng-container>
              </mat-error>
              <mat-error *ngIf="maxAdvanceDays$ | async as maxAdvanceDays">
                <ng-container i18n>Maximum Advance Booking is</ng-container> {{ maxAdvanceDays }}
                <ng-container i18n>days</ng-container>
              </mat-error>
            </div>

            <div [class.hidden]="taxes.controls.length === 0" class="mb-3">
              <h6 class="section-title" i18n>Taxes</h6>
              <div
                formArrayName="taxes"
                *ngFor="let item of taxes.controls; let i = index"
                class="d-grid gap-col-3"
                style="grid-template-columns: 1fr 1fr 1fr"
              >
                <ng-container [formGroupName]="i">
                  <mat-form-field2 class="mat-block">
                    <input type="text" formControlName="taxName" matInput i18n-placeholder placeholder="Tax Name:" />
                  </mat-form-field2>
                  <mat-form-field2 class="mat-block">
                    <input
                      type="number"
                      min="0"
                      formControlName="taxRate"
                      matInput
                      i18n-placeholder
                      placeholder="Tax Rate:"
                    />
                  </mat-form-field2>
                  <mat-form-field2 class="mat-block">
                    <input
                      type="number"
                      min="0"
                      formControlName="taxAmount"
                      matInput
                      i18n-placeholder
                      placeholder="Tax Amount:"
                    />
                  </mat-form-field2>
                </ng-container>
              </div>
            </div>
            <div *ngIf="cost.value" class="bg-active2 rounded p-3 d-flex justify-content-between">
              <span class="text-uppercase text-light" i18n>Total: </span>
              <span class="text-bold">{{ cost.value?.total | tokeetCurrency : rental?.currency }}</span>
            </div>
          </div>
        </form>
        <div class="d-flex align-content-center gap-3 mt-3">
          <div class="flex-fill"></div>
          <ng-template [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{ dropup: true }"></ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actions let-dropup="dropup">
  <button (click)="close()" type="button" class="btn btn-outline-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <div class="btn-group dropdown" role="group" dropdown [dropup]="dropup">
    <button (click)="onSave(form)" type="button" class="btn btn-secondary-info">
      <span class="cs-icon cs-icon-save"></span>
      <ng-container i18n>Save</ng-container>
    </button>
    <button dropdownToggle type="button" class="btn btn-secondary-info dropdown-toggle"></button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li
        i18n-matTooltip
        matTooltip="Create the booking and send Booking Charges breakdown to guest via Email"
        matTooltipPosition="left"
      >
        <button type="button" class="dropdown-item" (click)="onSave(form, messagingChannelType.Email)" i18n>
          Save & Send Quote via Email
        </button>
      </li>
      <li
        i18n-matTooltip
        matTooltip="Create the booking and send Booking Charges breakdown to guest via SMS"
        matTooltipPosition="left"
      >
        <button type="button" class="dropdown-item" (click)="onSave(form, messagingChannelType.SMS)" i18n>
          Save & Send Quote via SMS
        </button>
      </li>
    </ul>
  </div>
</ng-template>
